const coin = {
  title: 'Coin',
  thisMonthRecharge: 'Bu ay yükleme',
  thisMonthReward: 'Bu ay ödül',
};

const bean = {
  title: 'Bean',
};

const gem = {
  title: 'Gem',
};

const pearl = {
  title: 'Pearl',
};

const list = {
  type: 'tür: {{type}}',
};

const coffee = {
  title: 'Kahve',
};

const chart = {
  monday: 'Pzt',
  tuesday: 'Sal',
  wednesday: 'Çar',
  thursday: 'Per',
  friday: 'Cum',
  saturday: 'Cmt',
  sunday: 'Paz',
};

export default {
  coin,
  bean,
  gem,
  pearl,
  coffee,
  chart,
  list,
  supporters: 'Destekçi',
  report: 'Rapor',
  detail: 'Detay',
  exchange: 'Değişim',
  recharge: 'Yükleme',
  yesterdayIncome: 'Dünkü gelir',
  todayIncome: 'Bugünkü gelir',
  monthIncome: 'Bu aylık gelir',
};
